import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'

const useAgencyIdParam = () => {
  const { agencyId } = useParams()

  const [id, setId] = useState<string | undefined>(agencyId)

  useEffect(() => {
    if (agencyId === id) return
    setId(agencyId)
  }, [agencyId])

  return id
}

export default useAgencyIdParam